import type { IconDefinition } from '../index.tsx';

export const iconBell: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconBell',
  icon: [
    16,
    16,
    [],
    '',
    'M8 0C5.23858 0 3 2.23858 3 5V7L1 9V11H15V9L13 7V5C13 2.23858 10.7614 0 8 0Z M5 13C5 14.6569 6.34315 16 8 16C9.65685 16 11 14.6569 11 13H5Z',
  ],
};
